module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av96-772319a9c891b3f09563dc4eb9f861d5.jpg";